$(() => {
    var url = $("#publ-url").val();
    $("#publ-url").remove();
    var id = $("#publ-id").val();
    $("#publ-id").remove();
    
    $(".p-social-btn.fb").click(() => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url + '/publicacoes/publicacao/' + id), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });

    $(".p-social-btn.tw").click(() => {
        window.open('http://twitter.com/share?url=' + encodeURIComponent(url + '/publicacoes/publicacao/' + id), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });
});